import { render } from "./ServiceCall.vue?vue&type=template&id=16e277f7"
import script from "./ServiceCall.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ServiceCall.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script